import React, { useEffect } from "react"
import { motion, useReducedMotion, useAnimation } from "framer-motion"
import useIsInViewport from "use-is-in-viewport"

const svgVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 2,
      ease: "easeOut",
    },
  },
}

const thermometerVariants = {
  hidden: { scaleY: 0 },
  visible: {
    scaleY: 1,
    transition: {
      duration: 1.5,
      ease: "easeInOut",
    },
  },
}

const globeVariants = {
  hidden: { scaleX: 0.25 },
  visible: {
    scaleX: 1,
    transition: {
      delay: 1.5,
      duration: 0.5,
      ease: "backInOut",
    },
  },
}

export default function MotionIconGlobeThermometer() {
  const reducedMotion = useReducedMotion()
  const controls = useAnimation()
  const [isIconInViewport, icon] = useIsInViewport()

  useEffect(() => {
    if (isIconInViewport) {
      controls.start("visible")
    }
    if (!isIconInViewport) {
      controls.start("hidden")
    }
  }, [controls, isIconInViewport])

  return (
    <motion.svg
      ref={icon}
      id="motion-icon-globe-thermometer"
      className="motion-icon"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 42 45"
      variants={reducedMotion ? null : svgVariants}
      initial="hidden"
      animate={controls}
    >
      <g id="thermometer">
        <motion.path
          id="fill"
          style={{ originX: "50%", originY: "97.88%" }}
          variants={reducedMotion ? null : thermometerVariants}
          d="M19.383 31.084h3.233v12.962h-3.233z"
          fill="#ed3024"
        />
        <path
          id="shape"
          d="M23.089 39.139v-10.76a2.089 2.089 0 10-4.178 0V39.14a3.3 3.3 0 104.178 0zM21 43.122a1.447 1.447 0 01-.839-2.628v-2.666H21v-.8h-.839v-1.7H21v-.8h-.839v-1.7H21v-.8h-.839v-1.7H21v-.8h-.839v-1.149a.839.839 0 011.678 0v12.115A1.447 1.447 0 0121 43.122z"
          fill="#231f20"
        />
      </g>
      <motion.g
        id="globe"
        style={{ originX: "50%", originY: "28.61%" }}
        variants={reducedMotion ? null : globeVariants}
      >
        <path
          id="globe-mask"
          d="M40.517 24.756a19.517 19.517 0 10-39.034 0h39.034z"
          fill="#a6d7da"
        />
        <path
          id="outer"
          d="M40.517 24.756a19.517 19.517 0 10-39.034 0h39.034z"
          fill="none"
          stroke="#231f20"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          id="inner"
          d="M30.759 24.756c0-10.78-4.369-19.518-9.759-19.518s-9.759 8.738-9.759 19.518h19.518z"
          fill="none"
          stroke="#231f20"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          id="vertical"
          d="M21 1v23.756"
          fill="none"
          stroke="#231f20"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          id="horizontal"
          d="M38.531 15.927H3.469"
          fill="none"
          stroke="#231f20"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </motion.g>
    </motion.svg>
  )
}
